import hero from "../../images/crm-hero.svg"

export default function CRMHero() {
  return (
    <>
      <section className="gray">
        <div className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center  py-10 lg:pt-48 lg:pb-20 xl:max-w-6xl xl:mx-auto">
          <article>
            <h1 className="mb-1">Time is Valuable — Make It Profitable!</h1>
            <p className="lg:text-2xl">
              Be-Broker's Back Office is designed to fit your business and free
              you from any worry. Create, plan and manage resources and contacts
              with ease – the way you work best! Get a hassle-free and
              customized Back office to meet your company needs. Contact us now
              for more details!
            </p>

            <a
              href="#request-a-demo"
              className="inline-block mt-5 mb-10 md:mb-0 btn-blue"
            >
              Request a Demo
            </a>
          </article>

          <article>
            <img
              src={hero}
              alt="Time is Valuable — Make It Profitable!"
              title="Time is Valuable — Make It Profitable!"
              className="block mx-auto"
            />
          </article>
        </div>
      </section>
    </>
  )
}
